import React, { useEffect, useState } from "react";
import SearchFeild from "../Components/Table/SearchFeild";
import JobRoleTable from "../Components/Table/JobRoleTable";
import FileUpload from "react-material-file-upload";
import { useMemo } from "react";
import { marked } from "marked";
import {
  Autocomplete,
  Button,
  Checkbox,
  Chip,
  Modal,
  Stack,
  TextField,
  Typography,
  Box,
  FormControl,
  FormLabel,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useForm } from "react-hook-form";
import { createFilterOptions } from "@mui/material/Autocomplete";
import { environmentDetails } from "../environment/environment";
import { useDispatch, useSelector } from "react-redux";
import { getJobRoleData, postJobRoles } from "../Redux/JobRole/action";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CurrencyList from "currency-list";
import {
  getCountryData,
  getCountryName,
  getCityName,
} from "../Redux/Country/action";
import { useDebounce } from "../hooks/useDebounce";
import ApiAlert from "../Components/AlertBox/ApiAlert";
import ReuseableLabel from "../Components/ReusableComponents/ReuseableLabel";
import { CkEditorComponent } from "../Components/ReusableComponents/CkEditor";
import { privateAxiosInstance } from "../utils/axiosInstance";
import { accessTokenHeadersObject } from "../utils/headers";
import axios from "axios";
import ATSJobDescripton from "./ATSJobDescripton";
import FilterList from "@mui/icons-material/FilterList";

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const apiUrl = environmentDetails.apiUrl;
const filter = createFilterOptions();

// initial state
export const initailState = {
  location: ["Mumbai"],
  country: " ",
  cities: [],
  jobOpeningId: "",
  role: "",
  image: "",
  skill: "",
  desc: "",
  currency: "",
};

// Responsive style for the modal
const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: "95vw", md: "80vw", lg: "70vw" },
  maxWidth: "1000px",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: { xs: 2, sm: 3, md: 4 },
  borderRadius: "8px",
  maxHeight: "95vh",
  overflowY: "auto",
};

const JobTabDashboard = () => {
  // All the logic (hooks, state, and functions) remains unchanged
  const dispatch = useDispatch();
  const [dataATS, setDataATS] = useState(null);
  const [open, setOpen] = React.useState(false);
  const [values, setValues] = useState([]);
  const [currValue, setCurrValue] = useState("");
  const [jobOpeningId, setJobOpeningId] = useState("");
  const [isDuplicateSkill, setIsDuplicateSkill] = useState(false);
  const [isEmptySkill, setIsEmptySkill] = useState(false);
  const [isEmptyRole, setIsEmptyRole] = useState(false);
  const [isEmptyDesc, setIsEmptyDesc] = useState(false);
  const [isEmptyCurrency, setIsEmptyCurrency] = useState(false);
  const [isEmptyLocation, setIsEmptyLocation] = useState(false);
  const [isEmptyCountry, setIsEmptyCountry] = useState(false);
  const [isEmptyCity, setIsEmptyCity] = useState(false);
  const [isEmptyImageFile, setIsEmptyImageFile] = useState(false);
  const [rows, setRows] = useState([]);
  const [search, setSearch] = useState("");
  const [image, setImage] = useState([]);
  const [selectedLocation, setSelectedLocation] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [selectedCity, setSelectedCity] = useState([]);
  const [currencyId, setCurrencyId] = useState(null);
  const [role, setRole] = useState([]);
  const [desc, setDesc] = useState([]);
  const [generateJDImgError, setGenerateJDImgError] = useState(false);

  const [yearsOfExperience, setYearsOfExperience] = useState("");
  const [generateJDImgErr, setGenerateJDImgErr] = useState(false);
  const [jdWords, setJdWords] = useState(100);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const { debouncedValue } = useDebounce(search);
  const [updateData, setUpdateData] = useState(null);
  const [generateJobDescriptionError, setGenerateJobDescriptionError] =
    useState(false);
  const [countries, setCountries] = useState([]);
  const [cities, setCities] = useState([]);
  const [alert, setAlert] = useState(false);
  const [alertContent, setalertcontent] = useState("");
  const [activeColor, setActiveColor] = useState("");
  const [alertStatus, setAlertStatus] = useState(Boolean);
  const [validImgtype, setValidImgtype] = useState(-1);
  const [validImgsize, setValidImgsize] = useState(-1);
  const [language, setLanguage] = useState("Select a Language");
  const [gptJson, setGptJson] = useState([]);

  // useEffect(() => {
  //   dispatch(getCountryName()).then((res) => {
  //     console.log(getCountryName);

  //     let data = Array.from(res.payload);
  //     let cc = data?.map((i) => i.country);
  //     setCountries(cc);
  //   });
  // }, []);
  

  const countryDataForCountryFetch = useSelector(
    (state) => state.countryReducer.country,
  );
  useEffect(() => {
    dispatch(getCountryData()).then((res) => {
      // Changing the priority of the Country Data
      let countryDataForCountryFetch = res.payload;
      let cc = countryDataForCountryFetch?.map((i) => i.name);
      setCountries(cc);
    });
  }, []);

  /*useEffect(() => {
    if (selectedCountry != null) {
      dispatch(getCityName(selectedCountry.country)).then((res) => {
        if (res) {
          setCities(res);
        } else {
          setCities([""]);
        }
      });
    }
  }, [selectedCountry]);*/// AFTER
useEffect(() => {
  // Prevent API call with null/empty country
  if (!selectedCountry || selectedCountry === "null") {
    setCities([]);
    return;
  }

  dispatch(getCityName(selectedCountry?.country))
    .then((res) => {
      if (res) {
        setCities(res);
      } else {
        setCities([]);
      }
    })
    .catch((err) => {
      console.log(err);
      setCities([]);
    });
}, [selectedCountry]);

  const countryData = useSelector((state) => state.countryReducer.country);
  let indianCurrency;
  countryData.forEach((el) => {
    if (el.nationality === "Indian") {
      indianCurrency = el;
    }
  });

  useEffect(() => {
    setCurrencyId(indianCurrency?.id);
  }, [indianCurrency]);

  let countryObject = countryData?.find((x) => x.id === currencyId);
  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    reset(initailState);
    setOpen(false);
    setIsEmptyLocation(false);
    setIsEmptyCountry(false);
    setIsEmptyCity(false);
    setJobOpeningId("");
    setIsEmptySkill(false);
    setIsEmptyRole(false);
    setIsEmptyDesc(false);
    setActiveColor("");
    setIsEmptyImageFile(false);
    setIsEmptyCurrency(false);
    setValues([]);
    setSelectedLocation([]);
    setSelectedCountry(null);
    setSelectedCity([]);
    setRole("");
    setDesc("");
    setGptJson("");
    setCurrValue("");
    setYearsOfExperience("");
    setCurrencyId(indianCurrency?.id);
    setValidImgtype(-1);
    setGenerateJDImgErr(false);
    setJdWords(100);
    setImage([]);
    setValidImgsize(-1);
    setDataATS(null);
  };

  const jobRoleData = useSelector((state) => state.jobRoleReducer.jobRoles);
  // state for zoho data extraction
  const [isLoadingZoho, setIsLoadingZoho] = useState(false);
  // State for filtering data source (all, zoho, manual)
const [dataSourceFilter, setDataSourceFilter] = useState("all"); // "all", "zoho", "manual"
const filteredJobRoleData = useMemo(() => {
  if (!jobRoleData?.data) return jobRoleData;
  
  
  const filtered = jobRoleData.data.filter(job => {
    const jobSource = job.dataSource || job.source || 'manual';
    const isZohoByRole = job.role?.startsWith('Zoho:');
    const isZohoBySource = jobSource === "zoho" || jobSource === "n8n" || jobSource === 'zoho_recruiter';
    const isZoho = isZohoBySource || isZohoByRole;
    
    /*console.log(`Job: "${job.role}"`);
    console.log(`  dataSource: "${job.dataSource}"`);
    console.log(`  source: "${job.source}"`);
    console.log(`  isZohoByRole: ${isZohoByRole}`);
    console.log(`  isZohoBySource: ${isZohoBySource}`);
    console.log(`  final isZoho: ${isZoho}`);*/
    
    switch (dataSourceFilter) {
      case "zoho":
        return isZoho;
      case "manual":
        // Manual jobs are those that are NOT Zoho
        return !isZoho;
      default:
        return true;
    }
  });
  
  //console.log(`Filter "${dataSourceFilter}": ${filtered.length} jobs`);
  
  // Apply search filter if there's a search term
  if (search && search.trim()) {
    const searchTerm = search.toLowerCase().trim();
    const searchFiltered = filtered.filter(job => {
      const roleText = (job.role || '').toString().toLowerCase();
      const skillText = Array.isArray(job.skill) 
        ? job.skill.join(', ').toLowerCase()
        : (job.skill || '').toString().toLowerCase();
      const countryText = (job.country || '').toString().toLowerCase();
      const citiesText = Array.isArray(job.cities)
        ? job.cities.join(', ').toLowerCase()
        : (job.cities || '').toString().toLowerCase();
      
      return (
        roleText.includes(searchTerm) ||
        skillText.includes(searchTerm) ||
        countryText.includes(searchTerm) ||
        citiesText.includes(searchTerm)
      );
    });
    
    return {
      ...jobRoleData,
      data: searchFiltered,
      total: searchFiltered.length
    };
  }
  
  return {
    ...jobRoleData,
    data: filtered,
    total: filtered.length
  };
}, [jobRoleData, dataSourceFilter, search]);
/*// ADD DEBUG LOGGING HERE
useEffect(() => {
  console.log('Filter:', dataSourceFilter);
  console.log('Original data:', jobRoleData?.data?.length);
  console.log('Filtered data:', filteredJobRoleData?.data?.length);
}, [dataSourceFilter, jobRoleData, filteredJobRoleData]);*/
// Add this to see what's happening with the filter
useEffect(() => {
  /*console.log('=== FILTER STATUS ===');
  console.log('Current filter:', dataSourceFilter);
  console.log('Total jobs in database:', jobRoleData?.data?.length);*/
  
  if (jobRoleData?.data) {
    const zohoJobs = jobRoleData.data.filter(job => {
      const jobSource = job.dataSource || job.source || 'manual';
      const isZohoByRole = job.role?.startsWith('Zoho:');
      return jobSource === "zoho" || jobSource === "n8n" || isZohoByRole;
    });
    
    //console.log('Zoho jobs found:', zohoJobs.length);
    zohoJobs.forEach((job, index) => {
     // console.log(`  Zoho Job ${index + 1}: "${job.role}" (dataSource: ${job.dataSource}, source: ${job.source})`);
    });
    
    const manualJobs = jobRoleData.data.filter(job => {
      const jobSource = job.dataSource || job.source || 'manual';
      const isZohoByRole = job.role?.startsWith('Zoho:');
      return !(jobSource === "zoho" || jobSource === "n8n" || isZohoByRole);
    });
    
   // console.log('Manual jobs found:', manualJobs.length);
  }

}, [dataSourceFilter, jobRoleData]);

  useEffect(() => {
    dispatch(getCountryData());
  }, []);

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: initailState,
  });

  const generateJDImg = async () => {
    if (desc?.length <= 0) {
      setGenerateJDImgError(true);
      return;
    }

    const minimumRequirementList = await getMinimumRequirementListFromRefData();
    const minReqKeys = filterMinimumReqFieldsFromRefData(
      minimumRequirementList,
    );
    console.log("MIN REQUIRED KETS", minReqKeys);
    const outputTemplate = createPromptOutputPayload(minReqKeys);
    console.log("outputTemplate is", outputTemplate);

    const visionResponse = await axios.post(
      `${apiUrl}JD/extractMinimumRequirementFromJD`,
      {
        outputTemplate,
        jobDescription: desc,
      },
    );
    console.log("final json is in edit : ", visionResponse);
    console.log("description is", desc);

    if (visionResponse) {
      const finalJson = extractJsonFromVisionResponse(visionResponse);
      console.log(finalJson);
      console.log("final json", finalJson);
      console.log(
        "Final Extracted JSON:\n",
        JSON.stringify(finalJson, null, 2),
      );
      setGptJson(finalJson);
    }

    const data = {
      desc: removeQuotes(desc.replace(/<[^>]*>|[\r\n]|\\/g, "")),
      jobRole: role,
      yearsOfExperience: yearsOfExperience,
      skills: values,
    };
    console.log("checking the data in edit in chatgpt", data);
    privateAxiosInstance
      .post(
        "/questionnaire/generate-jdImage?processName=Initiation_preScreeningProcess",
        { ...data },
        {
          responseType: "arraybuffer",
          headers: { ...accessTokenHeadersObject() },
        },
      )
      .then((res) => {
        console.log("responceeeeeeee in edit", res);
        const blob = new Blob([res.data], { type: "image/png" });
        const imageFile = new File([blob], `jdImage${Date.now()}.png`, {
          type: "image/png",
        });
        console.log("image of js in edit: ", imageFile);
        setImage([imageFile]);
        setIsEmptyImageFile(false);
        setValidImgtype(1);
        setValidImgsize(1);
      })
      .catch((err) => {
        console.log("Error:", err);
        setValidImgtype(0);
        setValidImgsize(0);
      });
  };

  const getMinimumRequirementListFromRefData = async (iscat = true) => {
    const url = `${environmentDetails.refDateApi}cv_score/instances`;
    const params = { iscat: iscat.toString() };
    try {
      const response = await privateAxiosInstance.get(url, {
        headers: { ...accessTokenHeadersObject() },
      });
      console.log("success");
      console.log(response.data);
      return response.data;
    } catch (error) {
      console.log("error");
      console.error("Error fetching CV score instances:", error.message);
      return {};
    }
  };
  function filterMinimumReqFieldsFromRefData(refData) {
    const keys = [];
    const dataArray = refData?.data || [];
    for (const item of dataArray) {
      if (item?.name) {
        keys.push(item.name);
      }
    }
    console.log("refdata", refData);
    console.log("keys", keys);
    return keys;
  }
  function createPromptOutputPayload(keys) {
    const output = {};
    keys.forEach((key) => {
      output[key] = "";
    });
    return output;
  }

  function extractJsonFromVisionResponse(rawString) {
    console.log("rawstring", rawString.data.data);
    try {
      const start = rawString.data.data.indexOf("{");
      const end = rawString.data.data.lastIndexOf("}") + 1;
      const jsonStr = rawString.data.data.substring(start, end);
      return JSON.parse(jsonStr);
    } catch (error) {
      console.error("JSON parsing failed:", error.message);
      return {};
    }
  }

  // =======================
// FIX NULL COUNTRY & CITY
// =======================
useEffect(() => {
  // =======================
  // NORMAL ADD JOB ROLE
  // =======================
  if (!dataATS) {
    reset({
      country: "",
      cities: [],
      role: "",
      desc: "",
      yearsOfExperience: "",
      skill: "",
      jobOpeningId: "",
    });

    setSelectedCountry(null);
    setSelectedCity([]);
    setRole("");
    setDesc("");
    setValues([]);
    setYearsOfExperience("");
    setJobOpeningId("");

    return;
  }

  // =======================
  // COUNTRY
  // =======================
  const finalCountry =
    dataATS?.country &&
    dataATS?.country !== "null"
      ? dataATS.country
      : "India";

  // =======================
  // CITY
  // =======================
  const finalCity =
    dataATS?.city &&
    dataATS?.city !== "null"
      ? dataATS.city
      : "Mumbai";

  reset({
    country: finalCountry,
    cities: [finalCity],
    role: dataATS?.postingTitle || "",
    desc: dataATS?.Job_Description || "",
    yearsOfExperience: dataATS?.experience || "",
    skill: dataATS?.requiredSkills || "",
    jobOpeningId: dataATS?.jobOpeningId || "",
  });

  // =======================
  // SET COUNTRY
  // =======================
  setSelectedCountry({
    country: finalCountry,
  });

  setIsEmptyCountry(false);

  // =======================
  // SET CITY
  // =======================
  setSelectedCity([
    {
      id: `${finalCity}-1`,
      label: finalCity,
    },
  ]);

  setIsEmptyCity(false);

  // =======================
  // ROLE
  // =======================
  setRole(dataATS?.postingTitle || "");

  // =======================
  // DESCRIPTION
  // =======================
  if (dataATS?.Job_Description) {
    let jds = JSON.stringify(dataATS.Job_Description)
      .slice(1, -1)
      .replace(/\\\\n/g, " ");

    setDesc(jds);
    setIsEmptyDesc(false);
  } else {
    setDesc("");
  }

  // =======================
  // EXPERIENCE
  // =======================
  setYearsOfExperience(dataATS?.experience || "");

  // =======================
  // SKILLS
  // =======================
  if (dataATS?.requiredSkills) {
    setValues(dataATS.requiredSkills.split(","));
    setIsEmptySkill(false);
  } else {
    setValues([]);
  }

  // =======================
  // JOB OPENING ID
  // =======================
  setJobOpeningId(dataATS?.jobOpeningId || "");

}, [dataATS, reset]);

  const onSubmit = (data) => {
    if (!selectedCountry) setIsEmptyCountry(true);
    if (selectedCity?.length === 0) setIsEmptyCity(true);
    if (role?.length === 0) setIsEmptyRole(true);
    if (values?.length === 0) setIsEmptySkill(true);
    if (image?.length === 0) setIsEmptyImageFile(true);
    if (!currencyId) setIsEmptyCurrency(true);

    if (
      !role ||
      !selectedCountry ||
      selectedCity.length === 0 ||
      values?.length === 0 ||
      image?.length === 0 ||
      !currencyId
    ) {
      return;
    }

    const imageFile = image[0];
    const formData = new FormData();
    formData.append("image", imageFile);

    const newData = {
      ...data,
      role,
      skill: values?.join(","),
      country: selectedCountry,//.country,
      cities: selectedCity.map((el) => el.label),
      currency: JSON.stringify(countryObject),
      desc: desc,
      gptJson: JSON.stringify(gptJson),
      jobOpeningId: jobOpeningId,
      words: jdWords,
    };
    Object.entries(newData).forEach(([key, value]) => {
      formData.append(key, value);
    });

    dispatch(postJobRoles(formData))
      .then((res) => {
        reset(initailState);
        setOpen(false);
        setAlert(true);
        setAlertStatus(res.payload.status);
        setalertcontent(res.payload.message);
        setValues([]);
        setDesc("");
        setDataATS("");
        setYearsOfExperience("");
        setRole("");
        setJobOpeningId("");
        setImage([]);
        setSelectedCountry(null);
        setSelectedCity([]);
        setCurrencyId(indianCurrency?.id);
        dispatch(getJobRoleData());
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleKeyUp = (e) => {
    const val = e.target.value.trim();
    const newValArr = values.map((i) => i.toLowerCase());
    if (
      !isDuplicateSkill &&
      e.keyCode === 188 &&
      val !== "" &&
      !newValArr.includes(val.toLowerCase())
    ) {
      setValues((oldState) => [...oldState, val]);
      setCurrValue("");
    } else {
      setIsDuplicateSkill(true);
    }
  };

  const handleChange = (e) => {
    const val = e.target.value.trim().toLowerCase();
    const lowerCaseArr = values.map((str) => str.trim().toLowerCase());
    setIsDuplicateSkill(lowerCaseArr.includes(val));
    setIsEmptySkill(values?.length === 0);
    setCurrValue(e.target.value.replace(/,/g, ""));
  };

  const handleDelete = (item, index) => {
    let arr = [...values];
    arr.splice(index, 1);
    setIsEmptySkill(arr.length === 0);
    setValues(arr);
  };

  const rolehandler = (event) => {
    const val = event.target.value.trim();
    setRole(val);
    setIsEmptyRole(val === "");
  };

  const jobOpeninghandler = (event) => {
    setJobOpeningId(event.target.value.trim());
  };

  const googleTranslate = async (text, targetLang = "en") => {
    try {
      let bodyData = {
        language: targetLang,
        desc: text,
      };
      privateAxiosInstance
        .post(
          `/questionnaire/translateJobDescription?processName=Initiation_preScreeningProcess`,
          bodyData,
          {
            headers: { ...accessTokenHeadersObject() },
          },
        )
        .then((res) => {
          setDesc(res.data.content);
        });
    } catch (error) {
      console.error("Translation error:", error);
      return text;
    }
  };

  const handleTranslate = async (language) => {
    setLanguage(language);
    if (language) {
      await googleTranslate(desc, language);
    }
  };

  const handleCkEditorChange = (e, editor) => {
    const editorData = editor?.getData();
    setDesc(editorData);
    if (!editorData) {
      setActiveColor("1px solid red");
      setIsEmptyDesc(true);
    } else {
      setActiveColor("");
      setIsEmptyDesc(false);
    }
  };

  const countryhandleChange = (event, value) => {
    if (value == null) {
      setIsEmptyCountry(true);
      setSelectedCountry(null);
      setIsEmptyCity(true);
      setSelectedCity([]);
    } else {
      setIsEmptyCountry(false);
      setIsEmptyCity(true);
      setSelectedCity([]);
      if (typeof value === "string") {
        setSelectedCountry({ country: value });
      } else if (value && value?.inputValue) {
        setSelectedCountry({ country: value.inputValue });
      } else {
        setSelectedCountry(value);
      }
    }
  };

  /*const cityOptions = useMemo(() => {
    if (!Array.isArray(cities)) return [];

    return cities.map((city, index) => ({
      id: `${city}-${index}`, // UNIQUE
      label: city,
    }));
  }, [cities]);*/
  

  // const cityhandleChange = (event, value) => {
  //   setIsEmptyCity(value == null);
  //   setSelectedCity(value ? value.map((val) => val) : []);
  // };
  const cityhandleChange = (event, value) => {
    setIsEmptyCity(!value || value.length === 0);
    setSelectedCity(value || []);
  };

  const handlePrettierDescription = () => {
    if (desc) {
      const plainTextDescription = new DOMParser().parseFromString(
        desc,
        "text/html",
      ).body.textContent;
      const bodyData = {
        prettier: true,
        jdDetails: plainTextDescription,
      };
      privateAxiosInstance
        .post(
          `/questionnaire/generateJobDescription?processName=Initiation_preScreeningProcess`,
          bodyData,
          {
            headers: { ...accessTokenHeadersObject() },
          },
        )
        .then((res) => {
          const html = marked(res.data.content);
          setDesc(html);
        })
        .catch((err) => {
          console.log("generate jd Err ", err);
        });
    }
  };

  const currencyOnChange = (event, value) => {
    if (value == null) {
      setCurrencyId("");
      setIsEmptyCurrency(true);
    } else {
      setCurrencyId(value?.id);
      setIsEmptyCurrency(false);
    }
  };
  const cityOptions = useMemo(() => {
  if (!Array.isArray(cities)) return [];

  return cities
    .filter((city) => city && city !== "null")
    .map((city, index) => ({
      id: `${city}-${index}`,
      label: city,
    }));
}, [cities]);

  const handleFileUploaderOnChange = (data) => {
    if (data?.length === 0) {
      setIsEmptyImageFile(true);
      setImage([]);
    } else {
      const fileName = data[0].name;
      const extension = fileName.split(".").pop().toLowerCase();
      const isSupported = ["png", "jpeg", "jpg"].includes(extension);
      const maxsize = 2 * 1024 * 1024;
      const filelimit = data[0].size < maxsize;
      if (isSupported && filelimit) {
        setValidImgtype(1);
        setValidImgsize(1);
        setIsEmptyImageFile(false);
        setImage(data);
      } else {
        setValidImgtype(isSupported ? 1 : 0);
        setValidImgsize(filelimit ? 1 : 0);
        setImage([]);
      }
    }
  };

  const atsData = (obj) => {
    setDataATS(obj);
  };

  const getJobRoleDataFn = () => {
    dispatch(getJobRoleData(page + 1, rowsPerPage, debouncedValue,null));
  };

  useEffect(() => {
    if (page !== 0) {
      setPage(0);
    }
  }, [rowsPerPage, debouncedValue]);

  useEffect(() => {
    getJobRoleDataFn();
  }, [page, rowsPerPage, debouncedValue]);

  const AlerthandleClose = (event, reason) => {
    if (reason === "clickaway") return;
    setAlert(false);
  };

  const handleGenerateJobDescription = () => {
    if (
      !role ||
      values.length === 0 ||
      !yearsOfExperience ||
      !selectedCountry ||
      selectedCity.length === 0
    ) {
      setGenerateJobDescriptionError(true);
      setTimeout(() => setGenerateJobDescriptionError(false), 4000);
      return;
    }

    const plainTextDescription = new DOMParser().parseFromString(
      desc,
      "text/html",
    ).body.textContent;

    const bodyData = {
      jobRole: role,
      skills: values,
      words: jdWords,
      yearsOfExperience: yearsOfExperience,
      country: selectedCountry,//.country,
      cities: selectedCity.map((el) => el.label),
      currency: JSON.stringify(countryObject),
      jdDetails: plainTextDescription,
    };
    privateAxiosInstance
      .post(
        `/questionnaire/generateJobDescription?processName=Initiation_preScreeningProcess`,
        bodyData,
        {
          headers: { ...accessTokenHeadersObject() },
        },
      )
      .then((res) => {
        const html = marked(res.data.content);
        console.log("html", html);
        setDesc(html);
        // setDesc(res.data.content);
        setIsEmptyDesc(false);
        const newData = {
          role,
          skill: values.join(","),
          yearsOfExperience,
          country: selectedCountry.country,
          cities: selectedCity.map((el) => el.label),
          currency: JSON.stringify(countryObject),
          desc: res.data.content,
        };
        setUpdateData(newData);
        setCurrencyId(countryObject?.id);
        setGenerateJDImgErr(false);
      })
      .catch((err) => {
        console.log("generate jd Err ", err);
      });
  };
   //data pull from zoho recuiter
  const extractFromZohoRecruiter = async () => {
  setIsLoadingZoho(true);
  try {
    const response = await fetch('https://porel3.app.n8n.cloud/webhook/pull-jobs', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        action: 'extract_job_roles',
        source: 'zoho_recruiter'
      })
    });

    const data = await response.json();
    console.log('📥 n8n response:', data);
    
    if (Array.isArray(data) && data.length > 0) {
      console.log(`📋 Found ${data.length} jobs from n8n`);
      
      let savedCount = 0;
      let duplicateCount = 0;
      let errorCount = 0;
      
      for (let i = 0; i < data.length; i++) {
        const job = data[i];
        
        try {
          console.log(`\n=== JOB ${i + 1}: ${job.Posting_Title} ===`);
          
          const formData = new FormData();
          
          // CRITICAL: Add a placeholder image
          const placeholderImage = new Blob([''], { type: 'image/png' });
          const imageFile = new File([placeholderImage], 'placeholder.png', { type: 'image/png' });
          formData.append('image', imageFile);
          
          const uniqueRole = `Zoho: ${job.Posting_Title || job.Job_Opening_Name || ''}`;
          formData.append('role', uniqueRole);
          
          formData.append('skill', job.Required_Skills || '');
          formData.append('country', job.Country || 'India');
          formData.append('cities', job.City || 'Mumbai');
          formData.append('yearsOfExperience', job.Work_Experience || '');
          formData.append('desc', job.Job_Description || '');
          formData.append('employmentType', job.Job_Type || '');
          formData.append('status', job.Job_Opening_Status || '');
          formData.append('salary', job.Salary || '');
          formData.append('positions', job.Number_of_Positions?.toString() || '');
          formData.append('industry', job.Industry || '');
          formData.append('targetDate', job.Target_Date || '');
          formData.append('source', 'zoho');
          formData.append('dataSource', 'zoho');
          formData.append('currency', JSON.stringify(indianCurrency));
          formData.append('words', '100');
          formData.append('gptJson', '{}');
          
          const uniqueJobId = `zoho_${job.Job_Opening_ID || job.id}_${Date.now()}`;
          formData.append('jobOpeningId', uniqueJobId);
          
          console.log('📤 FormData being sent (with image):');
          for (let [key, value] of formData.entries()) {
            if (key === 'image') {
              console.log(`  ${key}: [File - ${value.name}]`);
            } else {
              console.log(`  ${key}: ${value}`);
            }
          }
          
          const result = await dispatch(postJobRoles(formData));
          console.log('📥 Save result:', result);
          
          if (result && result.type === 'POST_JOBROLES_SUCCESS') {
            savedCount++;
            console.log(`✅ Successfully saved job ${savedCount}: ${job.Posting_Title}`);
          } else if (result?.payload?.message?.includes('already exist')) {
            duplicateCount++;
            console.log(`⚠️ Job already exists: ${job.Posting_Title}`);
          } else {
            errorCount++;
            console.log(`❌ Failed to save job: ${job.Posting_Title}`);
            console.log('📄 Error response:', result?.payload);
          }
          
          console.log(`=== END JOB ${i + 1} ===\n`);
          
        } catch (error) {
          errorCount++;
          console.error(`❌ Error saving job ${job.Posting_Title}:`, error);
        }
      }
      
      console.log(`\n📊 SUMMARY:`);
      console.log(`✅ Saved: ${savedCount}`);
      console.log(`⚠️ Duplicates: ${duplicateCount}`);
      console.log(`❌ Errors: ${errorCount}`);
      console.log(`📋 Total processed: ${data.length}`);

      if (savedCount > 0) {
        setAlert(true);
        setAlertStatus(true);
        setalertcontent(`Successfully imported ${savedCount} job roles from Zoho`);
        
        setTimeout(() => {
          console.log('🔄 Refreshing data...');
          setPage(0);
          getJobRoleDataFn();
        }, 2000);
        
      } else if (duplicateCount > 0) {
        setAlert(true);
        setAlertStatus(true);
        setalertcontent(`${duplicateCount} jobs already exist in database`);
        
      } else {
        setAlert(true);
        setAlertStatus(false);
        setalertcontent('Failed to save jobs - image field missing');
      }
      
    } else {
      throw new Error('No job data found in n8n response');
    }
    
  } catch (error) {
    console.error('❌ Zoho extraction error:', error);
    setAlert(true);
    setAlertStatus(false);
    setalertcontent('Failed to extract data from Zoho.');
  } finally {
    setIsLoadingZoho(false);
  }
};
  function removeQuotes(inputString) {
    const regex = /^"(.*)"$/;
    return regex.test(inputString) ? inputString.slice(1, -1) : inputString;
  }
   
  // Add this to see what's happening with the filter
useEffect(() => {
  /*console.log('Filter:', dataSourceFilter);
  console.log('Original data:', jobRoleData?.data?.length);
  console.log('Filtered data:', filteredJobRoleData?.data?.length);*/
  
  // Log each job's dataSource
  if (jobRoleData?.data) {
    jobRoleData.data.forEach((job, index) => {
      //console.log(`Job ${index}: ${job.role} - dataSource: ${job.dataSource || 'undefined'}`);
    });
  }
}, [dataSourceFilter, jobRoleData, filteredJobRoleData]);
  useEffect(() => {
    if (updateData) {
      reset(updateData);
    }
  }, [updateData]);

  return (
    <>
      {alert && (
        <ApiAlert
          open={alert}
          snackbaronClose={AlerthandleClose}
          alertonClose={AlerthandleClose}
          alertType={alertStatus ? "success" : "error"}
          Content={alertContent}
        />
      )}
      <Box
        sx={{
          width: "100%",
          overflowY: "auto",
          "&::-webkit-scrollbar": { display: "none" },
          msOverflowStyle: "none",
          scrollbarWidth: "none",
        }}
      >
        <SearchFeild
        
          buttonName="Add Job Role"
          placeholder="Search Job Role or Primary Skills"
          TextFieldWidth="70%"
          width="100%"
          large="0px"
          marginBottom={"15px"}
          Navigate={handleOpen}
          onChange={(e) => setSearch(e.target.value)}
          roleModule={"Job Role"}
          //Zoho button props
           zohoButtonName="Import From Zoho" 
           onZohoClick={extractFromZohoRecruiter} 
           showZohoButton={true}  
           isLoadingZoho={isLoadingZoho} 
            dataSourceFilter={dataSourceFilter}
             onFilterChange={(e) => {
    setDataSourceFilter(e.target.value);
    setPage(0);
  }}
  showFilter={true}
 
        />
        
        <JobRoleTable
          jobRoleData={filteredJobRoleData}
          search={search}
          page={page}
          setPage={setPage}
          rowsPerPage={rowsPerPage}
          setRowsPerPage={setRowsPerPage}
          getJobRoleDataFn={getJobRoleDataFn}
        />
        <Modal open={open} aria-labelledby="add-job-role-title">
          <Box sx={modalStyle}>
            <form onSubmit={handleSubmit(onSubmit)}>
              <IconButton
                onClick={handleClose}
                sx={{ position: "absolute", top: 8, right: 8 }}
                aria-label="close"
              >
                <CloseIcon />
              </IconButton>
              <Typography
                id="add-job-role-title"
                sx={{
                  fontSize: { xs: "24px", md: "30px" },
                  fontWeight: 600,
                  textAlign: "center",
                  mb: 2,
                  color: "primary.darkText",
                }}
              >
                Add Job Role
              </Typography>

              <Stack spacing={2.5}>
                <ATSJobDescripton atsData={atsData} />

                <Stack direction={{ xs: "column", md: "row" }} spacing={2}>
                  <TextField
                    fullWidth
                    label={<ReuseableLabel label={"Job Role"} />}
                    variant="outlined"
                    defaultValue={role}
                    onKeyUp={rolehandler}
                    error={isEmptyRole}
                    helperText={isEmptyRole && "Job Role is required"}
                    InputLabelProps={{ shrink: true }}
                    {...register("role")}
                  />
                  <TextField
                    disabled
                    fullWidth
                    label="Job Opening Id"
                    variant="outlined"
                    defaultValue={jobOpeningId}
                    InputLabelProps={{ shrink: true }}
                    {...register("jobOpeningId")}
                  />
                </Stack>

                <TextField
                  fullWidth
                  label="Years of Experience"
                  variant="outlined"
                  defaultValue={yearsOfExperience}
                  onKeyUp={(e) => setYearsOfExperience(e.target.value)}
                  InputLabelProps={{ shrink: true }}
                  {...register("yearsOfExperience")}
                />

                <FormControl fullWidth error={isEmptySkill}>
                  <FormLabel
                    sx={{
                      position: "absolute",
                      top: "-10px",
                      left: "10px",
                      bgcolor: "background.paper",
                      px: "4px",
                      fontSize: "0.75rem",
                    }}
                  >
                    <ReuseableLabel label={"Skills"} />
                  </FormLabel>
                  <Box
                    sx={{
                      border: 1,
                      borderColor: isEmptySkill ? "error.main" : "grey.400",
                      borderRadius: 1,
                      p: 1.5,
                      minHeight: "56px",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        flexWrap: "wrap",
                        gap: 0.5,
                        mb: values.length > 0 ? 1 : 0,
                      }}
                    >
                      {values.map((item, index) => (
                        <Chip
                          key={index}
                          size="small"
                          label={item}
                          onDelete={
                            !dataATS?.requiredSkills
                              ? () => handleDelete(item, index)
                              : null
                          }
                        />
                      ))}
                    </Box>
                    <TextField
                      variant="standard"
                      fullWidth
                      placeholder="Type a skill and press comma (,)"
                      value={currValue}
                      onChange={handleChange}
                      onKeyDown={handleKeyUp}
                      InputProps={{ disableUnderline: true }}
                      inputProps={{ readOnly: !!dataATS?.requiredSkills }}
                      error={isDuplicateSkill}
                    />
                  </Box>
                  {(isDuplicateSkill || isEmptySkill) && (
                    <Typography
                      variant="caption"
                      color="error.main"
                      sx={{ ml: 2, mt: 0.5 }}
                    >
                      {isDuplicateSkill
                        ? `"${currValue}" already exists.`
                        : "At least one skill is required."}
                    </Typography>
                  )}
                </FormControl>

                <Stack direction={{ xs: "column", md: "row" }} spacing={2}>
                  {/* <Autocomplete
                    fullWidth
                    options={countries ||[]}
                    value={
                    selectedCountry &&
    selectedCountry.country !== "null"
      ? selectedCountry
      : null
  }
    isOptionEqualToValue={(option, value) =>
    option?.country === value?.country
  }
  getOptionLabel={(option) => option?.country || ""}
  onChange={(e, newValue) => {
    setSelectedCountry(newValue);
  }}
                    /*onChange={countryhandleChange}
                    getOptionLabel={(option) => option.country || option || ""}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label={<ReuseableLabel label={"Country"} />}
                        error={isEmptyCountry}
                        helperText={isEmptyCountry && "Country is required"}
                      />
                    )}
                  />*/}
                  <Autocomplete
                    fullWidth
                    //options={countries || []}
                    options={
                      countryData?.map((item) => ({
                      country: item.name,
                      })) || []
                    }
                    value={selectedCountry || null}
                     onChange={(event, newValue) => {
                     // Reset city when country changes
                     setSelectedCountry(newValue || "");
                     setSelectedCity([]);

                    setIsEmptyCountry(!newValue);
                    setIsEmptyCity(true);
                    }}
                      isOptionEqualToValue={(option, value) =>
                        option?.country === value?.country
                       }
                    //getOptionLabel={(option) => option || ""}
                    getOptionLabel={(option) => {
                    if (typeof option === "string") return option;
                      return option?.country || "";
                    }}
                    renderInput={(params) => (
                    <TextField
                    {...params}
                    label={<ReuseableLabel label={"Country"} />}
                    error={isEmptyCountry}
                    helperText={isEmptyCountry && "Country is required"}
                    />
                    )}
                  />
                  <Autocomplete
                    multiple
                    fullWidth
                    options={cityOptions}
                    value={selectedCity||[]}
                    onChange={cityhandleChange}
                    getOptionLabel={(option) => option.label}
                    isOptionEqualToValue={(option, value) =>
                      option.id === value.id
                    }
                    renderOption={(props, option) => (
                      <li {...props} key={option.id}>
                        {option.label}
                      </li>
                    )}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label={<ReuseableLabel label="City" />}
                        error={isEmptyCity}
                        helperText={isEmptyCity && "City is required"}
                      />
                    )}
                  />

                  {/* <Autocomplete
                    multiple
                    fullWidth
                    options={cities || []}
                    value={selectedCity}
                    onChange={cityhandleChange}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label={<ReuseableLabel label={"City"} />}
                        error={isEmptyCity}
                        helperText={isEmptyCity && "City is required"}
                      />
                    )}
                  /> */}
                </Stack>

                <Box>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: { xs: "column", md: "row" },
                      justifyContent: "space-between",
                      alignItems: { xs: "flex-start", md: "center" },
                      gap: 2,
                      mb: 1,
                    }}
                  >
                    <Typography variant="subtitle1" sx={{ fontWeight: 500 }}>
                      Job Description
                    </Typography>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1.5,
                        flexWrap: "wrap",
                      }}
                    >
                      <FormControl size="small">
                        <InputLabel>Translate</InputLabel>
                        <Select
                          value={language}
                          label="Translate"
                          onChange={(e) => handleTranslate(e.target.value)}
                        >
                          <MenuItem value="Select a Language" disabled>
                            Select Language
                          </MenuItem>
                          <MenuItem value="English">English</MenuItem>
                          <MenuItem value="Bengali">Bengali</MenuItem>
                          <MenuItem value="Hindi">Hindi</MenuItem>
                          <MenuItem value="Tamil">Tamil</MenuItem>
                        </Select>
                      </FormControl>
                      <FormControl size="small" sx={{ minWidth: 80 }}>
                        <InputLabel>Words</InputLabel>
                        <Select
                          value={jdWords}
                          label="Words"
                          onChange={(e) => setJdWords(e.target.value)}
                        >
                          <MenuItem value={100}>100</MenuItem>
                          <MenuItem value={150}>150</MenuItem>
                          <MenuItem value={200}>200</MenuItem>
                          <MenuItem value={250}>250</MenuItem>
                          <MenuItem value={300}>300</MenuItem>
                        </Select>
                      </FormControl>
                      <Button
                        onClick={handleGenerateJobDescription}
                        size="small"
                        variant="contained"
                        sx={{ textTransform: "none" }}
                      >
                        Generate JD
                      </Button>
                      <Button
                        onClick={handlePrettierDescription}
                        size="small"
                        variant="contained"
                        sx={{ textTransform: "none" }}
                      >
                        Prettier
                      </Button>
                    </Box>
                  </Box>
                  <CkEditorComponent
                    ckEditorData={desc}
                    handleCkEditorChange={handleCkEditorChange}
                    disabled={!!dataATS?.jobDescription}
                  />
                  {generateJobDescriptionError && (
                    <Typography variant="caption" color="error.main">
                      Please fill Role, Skills, Experience, and Location to
                      generate a JD.
                    </Typography>
                  )}
                </Box>

                <Button
                  size="small"
                  variant="contained"
                  onClick={generateJDImg}
                  sx={{ textTransform: "none" }}
                >
                  Generate Image
                </Button>
                <Stack
                  direction={{ xs: "column", md: "row" }}
                  spacing={2}
                  alignItems="center"
                >
                  <Box sx={{ width: "100%", flex: 1 }}>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "flex-end",
                        mb: 1,
                      }}
                    ></Box>
                    <Box
                      sx={{
                        border:
                          isEmptyImageFile ||
                          validImgsize === 0 ||
                          validImgtype === 0
                            ? "1px solid red"
                            : "1px solid lightgray",
                        borderRadius: 1,
                        p: 0.5,
                      }}
                    >
                      <FileUpload
                        sx={{ height: "160px" }}
                        title={
                          validImgtype === 0
                            ? "Please upload image in .jpg, .jpeg, or .png format."
                            : validImgsize === 0
                              ? "File size exceeded (Max 2MB)."
                              : "Drag & drop image here, or click to select (JPG, PNG, JPEG | Max 2MB)"
                        }
                        value={image}
                        accept={"image/*,.jpg,.jpeg,.png"}
                        onChange={handleFileUploaderOnChange}
                      />
                    </Box>
                    {generateJDImgErr && (
                      <Typography variant="caption" color="error.main">
                        Job description is required to generate an image.
                      </Typography>
                    )}
                  </Box>
                  <Box
                    sx={{
                      width: "100%",
                      height: "220px",
                      borderRadius: 1,
                      border: 2,
                      borderColor: "primary.main",
                      overflow: "hidden",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flex: 1,
                    }}
                  >
                    {image.length > 0 && (
                      <img
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "contain",
                        }}
                        src={URL.createObjectURL(image[0])}
                        alt="Job visual"
                      />
                    )}
                  </Box>
                </Stack>

                <Autocomplete
                  fullWidth
                  options={countryData}
                  value={countryData.find((x) => x.id === currencyId) || null}
                  getOptionLabel={(option) =>
                    `${option.currency_symbol} : ${option.currency_name} [${option.currency}] [${option.name}]`
                  }
                  onChange={currencyOnChange}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={<ReuseableLabel label={"Currency"} />}
                      error={isEmptyCurrency}
                      helperText={isEmptyCurrency && "Currency is required"}
                    />
                  )}
                />

                <Stack
                  direction={{ xs: "column-reverse", sm: "row" }}
                  justifyContent="flex-end"
                  spacing={2}
                  sx={{ width: "100%", pt: 1 }}
                >
                  <Button
                    onClick={handleClose}
                    variant="contained"
                    color="secondary"
                    sx={{ textTransform: "none" }}
                  >
                    Cancel
                  </Button>
                  <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    sx={{ textTransform: "none" }}
                  >
                    Save
                  </Button>
                </Stack>
              </Stack>
            </form>
          </Box>
        </Modal>
      </Box>
    </>
  );
};

export default JobTabDashboard;
